import { Button, Col, Container, Nav, NavLink, Row } from "react-bootstrap";

export default function AdminNav() {
    return (
        <Container>
            <Row>
                <Col lg={4}>
                    <Button variant='success'><Nav.Link as={NavLink} href='./allPrompts'>All Prompts</Nav.Link></Button>
                </Col>
                <Col lg={4}><Button variant='success'><Nav.Link as={NavLink} href='./allInputs'>All Inputs Report</Nav.Link></Button></Col>

                <Col lg={4}>
                    <Button variant='success'><Nav.Link as={NavLink} href='./addprompt'>Add Prompt</Nav.Link></Button>
                </Col>
            </Row>
        </Container>
    )
}